import { Toast } from "antd-mobile";
import React from "react";
import { useTranslation } from "react-i18next";

import { useAuth } from "../../context/AuthContext";
import CustomPopup from "../CustomPopup";
import CustomRadioList from "../CustomRadioList";
import { useGetLangList } from "./hooks/language.hook";

function LangChanger({ visible, onClose }) {
  const { t, i18n } = useTranslation();
  const { lang, setLang } = useAuth();
  const getLangList = useGetLangList({});
  return (
    <CustomPopup visible={visible} onClose={onClose} title={t("mobile.personal.menu.lang")}>
      <CustomRadioList
        defaultValue={lang}
        radioItems={getLangList.data}
        onChange={(val) => {
          i18n.changeLanguage(val);
          setLang(val);
          Toast.show({
            icon: "success",
            content: t("mobile.personal.menu.lang.set"),
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }}
      />
    </CustomPopup>
  );
}

export default LangChanger;
